// 装饰器：打印 getter 名称和返回值
export function LogGetter(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
  const originalGetter = descriptor.get;
  if (!originalGetter) return descriptor;
  descriptor.get = function() {
    const value = originalGetter.call(this);
    // 这里使用 console.log，调试时可在控制台查看
    // eslint-disable-next-line no-console
    console.log(`${target.constructor.name} [getter] ${propertyKey}:`, value);
    return value;
  };
  return descriptor;
}
